import React, { useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import { Button } from "@commonsku/styles";
import { BulkActionConfigBase } from "../index";
import { oauth, fetchCsv, createDownload } from "../../../../utils";
import { useReportContext } from "../../report_context";
import {
  prepareSelectBillsLabel as prepareLabel,
  DeleteBillsButton,
  createExportToAccountingButton
} from "../common/bulk-actions";

const ExportToAccountingButton = createExportToAccountingButton(
  "BILL",
  (row: any) => row.bill_reference_number.bill_id,
  true
);

export function UnExportFromAccountingButton<T extends Record<string, unknown> = Record<string, unknown>>(
  {
    selected,
    setExecuting,
    disabled,
  }: {
    selected: T[],
    setExecuting: (executing?: boolean) => void,
    disabled?: boolean,
  }
) {
  const { fetchReport } = useReportContext();
  const bill_ids = useMemo(
    () => selected.map((row: any) => row.bill_reference_number.bill_id),
    [selected]
  );

  const handleClick = useCallback(async () => {
    if (bill_ids.length === 1) {
      if (!confirm("Are you sure to want to un-export this bill?")) {
        return;
      }
    } else {
      if (!confirm("Are you sure to want to un-export these bills?")) {
        return;
      }
    }
    setExecuting(true);
    try {
      await oauth("POST", "bill", { action: "unexport", ids: bill_ids });
      if (bill_ids.length === 1) {
        toast.success("1 bill unexported");
      } else {
        toast.success(`${bill_ids.length} bills unexported`);
      }
      await fetchReport();
    } catch (e) {
      toast.error("Unable to un-export bills");
    } finally {
      setExecuting(false);
    }
  }, [setExecuting, bill_ids]);

  return (
    <Button
      disabled={disabled}
      onClick={handleClick}
    >
      Un-Export
    </Button>
  );
}

export const BulkActions: BulkActionConfigBase = {
  prepareLabel,
  actions: [
    DeleteBillsButton,
    UnExportFromAccountingButton,
    ExportToAccountingButton,
  ]
};
